import { CurrencyCode } from '../../constants'
import { FreeEntryType, JackpotSitAndGoGame, JackpotSitAndGoPayout } from './models'
import { createJackpotSitAndGoGame } from './builders'

const initialJsngGamesState: JsngGameState = {
	configs: [
		createJackpotSitAndGoGame(1000, CurrencyCode.GOLD_COINS, FreeEntryType.Common)
			.build(),
		createJackpotSitAndGoGame(2000, CurrencyCode.GOLD_COINS, FreeEntryType.Uncommon)
			.build(),
		createJackpotSitAndGoGame(10000, CurrencyCode.GOLD_COINS,FreeEntryType.Rare)
			.build(),
		createJackpotSitAndGoGame(20000, CurrencyCode.GOLD_COINS,FreeEntryType.Legendary)
			.build(),
		createJackpotSitAndGoGame(0.25, CurrencyCode.SWEEPS, FreeEntryType.Common)
			.build(),
		createJackpotSitAndGoGame(1, CurrencyCode.SWEEPS, FreeEntryType.Uncommon)
			.build(),
		createJackpotSitAndGoGame(5, CurrencyCode.SWEEPS, FreeEntryType.Rare)
			.build(),
		createJackpotSitAndGoGame(10, CurrencyCode.SWEEPS, FreeEntryType.Legendary)
			.build(),
	]
}

export interface JsngGameState {
	configs: JackpotSitAndGoGame[]
}

export const jsngGamesReducer = (
	state: JsngGameState = initialJsngGamesState,
): JsngGameState => {
	return state
}
